import { Component, input } from "@angular/core";

/** Fixed number of placeholder rows rendered while the accounts list loads. */
const PLACEHOLDER_ROW_COUNT = 4;

/**
 * Shared loading skeleton for a list of account rows — a pulsing placeholder for an account
 * icon, a two-line name, and a trailing value. Rendered while the accounts list is loading by
 * both the Today accounts widget (views.component) and the Manage Accounts page
 * (manage-accounts.component), so the markup lives in one place instead of being copy-pasted.
 * See gloss-client #4387.
 */
@Component({
  selector: "app-account-row-skeleton",
  standalone: true,
  templateUrl: "./account-row-skeleton.component.html",
  host: { class: "tw-block tw-w-full" },
})
export class AccountRowSkeletonComponent {
  /**
   * Classes for each row's card wrapper. Defaults to the design-system account card, so a bare
   * `<app-account-row-skeleton />` renders correctly; pass an override for page-specific chrome.
   */
  readonly cardClass = input(
    "tw-box-border tw-flex tw-w-full tw-flex-col tw-items-start tw-justify-between tw-overflow-hidden tw-rounded-2xl tw-bg-color-surface-card tw-p-4 tw-shadow-elevation-card",
  );

  /**
   * When true, the trailing column previews a balance bar plus a small tap-affordance
   * (chevron) square, matching the Today account row (`account-row-renderer`). Defaults
   * false → the two-line balance / sub-line stack used by the Manage Accounts card.
   */
  readonly showChevron = input(false);

  /**
   * Stable placeholder array — a plain constant, allocated once, so it is not re-created on every
   * change-detection pass. The call sites previously inlined a fresh `[1, 2, 3, 4]` literal.
   */
  protected readonly placeholders = Array.from({ length: PLACEHOLDER_ROW_COUNT });
}
